const setPaymentDefaults = (state, paymentDefaults) => {
  state.paymentDefaults = paymentDefaults;
};

const setPaymentResponse = (state, paymentResponse) => {
  state.paymentResponse = paymentResponse;
};

const setPaymentGateway = (state, paymentGateway) => {
  state.paymentGateway = paymentGateway;
};


export default {
  setPaymentDefaults,
  setPaymentResponse,
  setPaymentGateway,
};
